import {State} from '../../reducers'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { BasicLayout } from '../../modules/Layouts/basicLayout'
import FormularioLibroVentas from './Components/LibroVentas/FormularioLibroVentas'
import TableVentasDocumentos from './Components/LibroVentas/TableVentasDocumentos'
import { useEffect } from 'react'
import { clearLibroVentasModule } from '../../actions/libros/libros-ventas.actions'
import ModalCargarFormatoVentas from './Components/LibroVentas/ModalCargarFormatoVentas'
import { PLANTILLAS } from '../../utils/cargas.utils'
import { ModalDescargarPlantillas } from './Components/LibroVentas/ModalDescargarPlantillas'

const LibroVentas = () => {
  const dispatch = useDispatch();
  const {dataConsultaVentas, ventasModalFormatos, ventasModalCargaFormato} = useSelector((state: State) => state.libros)
  const buttonsPlantillas = [
    {
      label: "Retenciones",
      files: [PLANTILLAS.RETENCIONES_JSON, PLANTILLAS.RETENCIONES_XLSX]
    },
  ];

  useEffect(() => {
    dispatch(clearLibroVentasModule());
  }, []);

  return (
    <BasicLayout>
      {ventasModalFormatos && <ModalDescargarPlantillas buttons={buttonsPlantillas} />}
      {ventasModalCargaFormato && <ModalCargarFormatoVentas />}
      <div className='header-link'>
        <Link to={'/mas-opciones'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Libro de IVA para Ventas</h3>
      </div>
      <div className='separador'></div>
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card' style={{ height: 'auto' }}>
            <div className='w-layout-vflex card-content'>
              <FormularioLibroVentas />
            </div>
          </div>
        </div>
      </div>
      {
        dataConsultaVentas?.length > 0 && 
        (
          <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
            <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
              <div className='card' style={{ height: 'auto' }}>
                <div className='w-layout-vflex card-content'>
                  <TableVentasDocumentos />
                </div>
              </div>
            </div>
          </div>
        )
      }
    </BasicLayout>
  )
}

export default LibroVentas
